import React, {useEffect} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import LoginPage from '../login/LoginPage';
import {connect} from 'react-redux'
import { actionCheckIfUser, actionLogoutUser } from '../../store/acciones/accionesUsuario';
import Dashboard from '../dashboard/Dashboard';
import ProductsList from '../productos_view/ProductsList';
import ProductDetail from '../productos_view/ProductDetail';


function App({logged, checkIfUser,logoutUser, usuario}) {
  
   useEffect(() => {
    checkIfUser()
   });

  const logOut = () => {
    localStorage.removeItem('userToken');
    logoutUser()
  }	 
  return (
      <Switch>
        <Route exact path='/' render={(props)=>(logged?<Redirect to='/admin/ordenes/pendientes'/>:<LoginPage {...props}/> )} />
        <Route path='/admin' render ={(props)=>(logged?<Dashboard {...props} logout={logOut} />:<LoginPage {...props}/>)}/>
        <Route exact path={`/productos`} component={ProductsList} />
        <Route exact path={`/productos/:idProducto`} component={ProductDetail} />
      </Switch>
  );
}

const mapStateToProps = (state) => {
  return {
     logged: state.reducerSesion.logged,
     usuario:state.reducerUsuario.usuario
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    checkIfUser:()=>{
      dispatch(actionCheckIfUser())
    },
    logoutUser:()=>{
       dispatch(actionLogoutUser())
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(App)
